import { Component } from '@angular/core';

declare let $: any;
declare let ace: any;

@Component({
	selector: 'nm-scroll-up',
	templateUrl: './scroll-up.html'
})
export class NmScrollUp {

	public ngAfterViewInit() {
		this.scrollTopBtn();
	}


	// copy from ace.js
	// because initization in trandition js file not 100% works
	// modified to fit angular
	public scrollTopBtn() {
		//the scroll to top button
		let scroll_btn = $('.btn-scroll-up');
		if(scroll_btn.length > 0) {
			let is_visible = false;
			$(window).on('scroll.scroll_btn', function() {
				let scroll = <number>ace.helper.scrollTop();
				let h = <number>ace.helper.winHeight();
				let body_sH = document.body.scrollHeight;
				if(scroll > Math.floor(h / 4) || (scroll > 0 && body_sH >= h && h + scroll >= body_sH - 1)) {//|| for smaller pages, when reached end of page
					if(!is_visible) {
						scroll_btn.addClass('display');
						is_visible = true;
					}
				} else {
					if(is_visible) {
						scroll_btn.removeClass('display');
						is_visible = false;
					}
				}
			}).triggerHandler('scroll.scroll_btn');

			scroll_btn.on(ace.click_event, function(){
				let duration = Math.min(500, Math.max(100, Math.floor(ace.helper.scrollTop() / 3)));
				$('html,body').animate({scrollTop: 0}, duration);
				return false;
			});
		}
	}	
}


// WEBPACK FOOTER //
// ./src/widgets/scroll-up/scroll-up.ts